import React, { Component } from 'react'
import firebaseApp from '../firebase/firebase';
import HeaderForSingle from '../header/HeaderForSingle';
import ProductItem from '../ProductItem';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
let allData = [];
let ascending = false;

export default class Category extends Component {


    state = {
        productData: [],
        defaultCheckbox: ["ALL WATCH",
            "ON DEMAND",
            "REDDY STOCK",
            "UNDER 2000",
            "HIGH RANGE"],
        ManWatchCheckbox: [

            "ROLEX",
            "TAG HEUER",
            "RADO",
            "TISSOT",
            "FOSSIL",
            "ARMANI",
            "EDIFICE",
            "DIESEL",
            "HUBLOT",
            "CARTIER",
            "AP",
            "BREITLING",
            "OMEGA",
            "INVICTA",
            "G-SHOCK",
            "OTHER BRAND",
            "SLIM MODEL",
            "DIMOND",
            "LEATHER BELT",
            "CHAIN BELT",
            "MECHANICAL",
            "AUTOMATIC",
        ],
        WomanWatchCheckbox: [

            "TOP TRAND",
            "RADO",
            "ROLEX",
            "FOSSIL",
            "DW",
            "MICHAEL KORS",
            "BURBERRY",
            "VERSACE",
            "SWAROVSKI",
            "OTHER BRAND",
        ],
        LowerRangeCheckbox: [
            "Men's",
            "women's",

        ],
        productCategory: '',
        currentBrand: '',
        NumberOfProductToShow: 30

    }

    componentDidMount() {
        let productCategory = window.location.href.split('/')

        this.setState({ productCategory: productCategory[4], currentBrand: productCategory[5] }, () => {
            this.get_data_from_database(this.state.productCategory);

        })

    }

    componentDidUpdate(preProps) {
        if (this.props !== preProps) {
            let productCategory = window.location.href.split('/')
            this.setState({ productCategory: productCategory[4], currentBrand: productCategory[5] }, () => {
                this.get_data_from_database(this.state.productCategory);

            })
        }
    }


    get_data_from_database = (productCategory) => {
        console.log(productCategory)
        let productDataArray = []
        const db = firebaseApp.firestore();
        db.collection("Products").where("projectOwner", "==", 'Amit').where('category', '==', productCategory).where('status', '==', 1).get().then(
            (querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    productDataArray.push(doc.data())
                });
                // productDataArray.sort((a, b) => {
                //     return a.productNo - b.productNo;
                // });
                allData = productDataArray
                this.setState({ productData: productDataArray }, () => {
                    if (this.state.currentBrand && document.getElementById(this.state.currentBrand)) {
                        document.getElementById(this.state.currentBrand).click()
                    }
                })
            }).catch(err => {
                console.error(err)
            });
    }

    handleWatchDropDown = (value) => {

        this.setState({ productData: allData }, () => {
            let selectedProductCompany = value;
            let selectedProductArray = [];
            for (let i = 0; i < this.state.productData.length; i++) {
                if (this.state.productData[i].productCompany.includes(selectedProductCompany)) {
                    selectedProductArray.push(this.state.productData[i])
                }
            }

            this.setState({ productData: selectedProductArray })
        })

    }

    sortByPrice = () => {
        let objs = this.state.productData;
        if (ascending) {
            document.getElementById('priceSort').innerHTML = 'Low to high'
            objs.sort((a, b) => {
                return b.price - a.price;
            });
            ascending = !ascending
        } else {
            document.getElementById('priceSort').innerHTML = 'High to low'
            objs.sort((a, b) => {
                return a.price - b.price;
            });
            ascending = !ascending
        }

        this.setState({ productData: objs })
    }

    showMoreItems = () => {
        if (this.state.NumberOfProductToShow < 90) {
            this.setState({ NumberOfProductToShow: Number(this.state.NumberOfProductToShow) + 30 })
        }
    }

    render() {
        return (
            <div className='container-fluid p-0'>
                {this.state.productData &&
                    <HeaderForSingle totalItem={this.state.productData.length} />}
                <div className="row top-space">
                    <div className="container-fluid p-0">
                        <div className="col-12 p-0">
                            <div className="sticky-header ">
                                <div className="d-flex align-items-center justify-content-between">


                                    <div className="chart-btn-top d-flex  overflow-auto">
                                        {this.state.defaultCheckbox.map((item, i) => {
                                            return (
                                                <button id={item + i} onClick={() => { this.handleWatchDropDown(item) }} className="btn high-low   mr-2">{item}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="sticky-header ">
                                <div className="d-flex align-items-center justify-content-between">


                                    <div className="chart-btn-top d-flex  overflow-auto">

                                        {this.state.productCategory === 'man-watch' ?
                                            this.state.ManWatchCheckbox.map((item, i) => {
                                                return (
                                                    <button id={item.replace(' ', '-').toLowerCase()} onClick={() => { this.handleWatchDropDown(item) }} className="btn high-low   mr-2">
                                                        <Link className='text-white' to={'/category' + "/" + this.state.productCategory + '/' + item.replace(' ', '-').toLowerCase()} >
                                                            {item} </Link></button>
                                                )
                                            }) : ''}

                                        {this.state.productCategory === 'woman-watch' ? this.state.WomanWatchCheckbox.map((item, i) => {
                                            return (
                                                <button id={item.replace(' ', '-').toLowerCase()} onClick={() => { this.handleWatchDropDown(item) }} className="btn high-low   mr-2">{item}</button>
                                            )
                                        }) : ''}
                                        {this.state.productCategory === 'lower-range-watch' ? this.state.LowerRangeCheckbox.map((item, i) => {
                                            return (
                                                <button id={item.replace(' ', '-').toLowerCase()} onClick={() => { this.handleWatchDropDown(item) }} className="btn high-low   mr-2">{item}</button>
                                            )
                                        }) : ''}
                                    </div>
                                </div>
                            </div>
                            <button onClick={this.sortByPrice} className="btn high-low" id='priceSort'>Low to High</button>
                        </div>
                    </div>
                </div>

                <div className="row top-space">
                    <div className="container-fluid p-0">
                        <div className="row align-items-center justify-content-center">
                            {this.state.productData.map(
                                (projectItem, index) => {
                                    // if (index < this.state.NumberOfProductToShow) {
                                    return (
                                        <React.Fragment key={index}>
                                            <ProductItem
                                                data={projectItem}
                                                showProduct={this.showProduct}
                                            />
                                        </React.Fragment>
                                    );

                                    // }

                                },
                            )}
                        </div>
                    </div>

                    {/* {(this.state.NumberOfProductToShow < 90 && this.state.NumberOfProductToShow > 30) ? <button onClick={this.showMoreItems} className="btn btn-blue  w-100">Show More Items</button> : ''} */}
                </div>
            </div>
        )
    }
}
